import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Tile, Loading } from '@cv/eds-react';
import '../CustomEDSComponents/configuration.css';
import validator from '@rjsf/validator-ajv8';
import {
  RJSFSchema,
  UiSchema,
  RegistryWidgetsType,
  ErrorListProps
} from '@rjsf/utils';
import Form from '@rjsf/core';
import { Button } from '@cv/eds-react/lib/components/button';
import usePostWorkspace from '../../hooks/usePostWorkspace';
import { notification } from '@cv/eds-react/lib/components/notification';
import { CustomEDSInput } from '../CustomEDSComponents';
import { useHistory } from 'react-router-dom';

const CreateWorkspace = (props) => {
  // Create New Workspace
  const {
    mutateAsync,
    isLoading,
    isError,
    error
  } = usePostWorkspace();
  const history = useHistory();
  
  const widgets: RegistryWidgetsType = {
    TextWidget: CustomEDSInput,
  };
  const schemaObject: RJSFSchema = {
    "title": "Workspace Form",
    "type": "object",
    "required": [
      "name",
      "description"
    ],
    "properties": {
      "id": {
        "type": "string",
        "title": "ID",
        "default": ""
      },
      "name": {
        "type": "string",
        "title": "Name",
        "default": ""
      },
      "description": {
        "type": "string",
        "title": "Description",
        "default": ""
      }
    }
  };

  const uiSchemaObject: UiSchema = {
    'ui:classNames': 'custom-form', 
    id: {
      'ui:classNames': 'custom-field w-50',
    },
    name: {
      'ui:classNames': 'custom-field w-50',
    },
    description: {
      'ui:classNames': 'custom-field w-50',
    }
  };

  function transformErrors(errors, uiSchema) {
    return errors.map((error) => {
      return error;
    });
  }
  function ErrorListTemplate(props: ErrorListProps) {
    const { errors } = props;
    return <></>;
  }
  const handleSubmitObject = async ({ formData }, e) => {
    try {
      const response = await mutateAsync(formData);
      if (response.error) {
        setTimeout(() => {
          notification.notice("Some error occured. please try again after sometime.");
        }, 1000);
      } else {
        notification.notice('Workspace added successfully!!!');
        history.push('/workspace-config');
      }
    } catch (error) {
      setTimeout(() => {
        notification.notice(error?.response?.data?.message);
      }, 1000);
    }
  };

  const handleErrorObject = (e) => {
    e.forEach((error) => {
      notification.notice(error?.stack);
    });
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        {/* <Loading size="medium" /> */}
      </div>
    );
  } else if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <p>
          {error?.message ? error?.message : 'Something went wrong please try again.'}
        </p>
      </div>
    );
  } else {
    return (
      <div className="position-relative">
      <div className="row">
        <div className="column sm-12">
          <Tile>
            <Row>
              <Col span={12}>
                <Card>
                  <Form
                    schema={schemaObject}
                    uiSchema={uiSchemaObject}
                    onSubmit={handleSubmitObject}
                    onError={handleErrorObject}
                    widgets={widgets}
                    validator={validator}
                    transformErrors={transformErrors}
                    liveValidate
                    templates={{ ErrorListTemplate }}
                  >
                    <>
                      <Button type="submit" children="Submit" />
                    </>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Tile>
        </div>
      </div>
    </div>
    );
  }
};

export default React.memo(CreateWorkspace);
